import { useTranslation } from "react-i18next";

import { BodyTextSmall } from "~/components/Typographies";

const RequiredIndicator = () => {
	const { t } = useTranslation("common");

	return (
		<BodyTextSmall color="text.secondary" component="div">
			<BodyTextSmall color="error" component="span">
				*
			</BodyTextSmall>{" "}
			{t("forms.requiredField")}
		</BodyTextSmall>
	);
};

export default RequiredIndicator;
